import { useMemo } from "react";

const useSearchPagination = (data, searchTerm, currentPage, itemsPerPage = 10) => {
  // Normalize search term
  const term = searchTerm.toLowerCase();

  // Filter the data
  const filteredData = data.filter((item) => {
    // Case 1: item.name exists → EmployeeTypes
    if (item.name) {
      return item.name.toLowerCase().includes(term);
    }


    // Case 2: team member → full name search
    const fullName =
      `${item.first_name || ""} ${item.last_name || ""}`.toLowerCase();
      
        // CASE 3: Leave Requests
    if (item.leave_type || item.status || item.reason) {
      return (
        (item.leave_type || "").toLowerCase().includes(term) ||
        (item.status || "").toLowerCase().includes(term) ||
        (item.reason || "").toLowerCase().includes(term)
      );
    }

    return (
      fullName.includes(term) ||
      (item.email || "").toLowerCase().includes(term) ||
      (item.designation || "").toLowerCase().includes(term)
    );
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  return { filteredData, currentData, totalPages };
};

export default useSearchPagination;
